import { createElement, Component } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource } from 'react-dnd';
import { store, ComponentDesc, ShelfComponentProps, ScreenComponentProps, SettingsComponentProps, getDefaultSettings } from '../store';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BorderEdit from './common/BorderEdit';
import ColorPicker from './common/ColorPicker';
import BorderRadius from './common/BorderRadius';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { shelfComponentStyles } from './common/styles';
import withStyles from 'react-jss';
import BackgroundColorPicker from './common/BackgroundColorPicker';
import BorderRadius from './common/BorderRadius';

const svg = require('./icons/editor.svg');
//const menu_button = require('./icons/menu_button.svg');

interface WYSIWYGSettings {
    text: string;
}

let defaultTemplate = {
    type: 'WYSIWYG',
    style: {
        margin: 4,
        padding: 6,
        fontSize: 20,
        color: '#000000',
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: 15,
        paddingBottom: 30,
        paddingLeft: 15,
        paddingRight: 0,
        backgroundColor: '#FFFFFF',
    },
    settings: {
        text: 'Type Here...',
    },
    name: 'Text Editor',
};

const draggableShelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props: any): ComponentDesc<WYSIWYGSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        function collect(connect, monitor) {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
    observer,
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Text Editor</span>
            </div>
        </div>
    );
});

const draggableScreenComponent = observer((props: ScreenComponentProps<WYSIWYGSettings>) => {
    let { isDragging, descriptor } = props;
    return (
        <div
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
                minHeight: '10px',

                ...descriptor.style,
            }}
            onClick={(e) => store.selectComponent(descriptor)}
            dangerouslySetInnerHTML={{
                __html: descriptor.settings.text ? descriptor.settings.text : '',
            }}
        />
    );
});

@observer
class SettingsComponent extends Component<SettingsComponentProps<WYSIWYGSettings>, any> {
    state = {
        editorState: EditorState.createEmpty(),
        descriptor: {
            id: 0,
        },
    };
    onEditorStateChange: Function = (editorState: any) => {
        this.setState({
            editorState,
        });
        this.props.descriptor.settings.text = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    };

    static getDerivedStateFromProps(props, state) {
        if (state.descriptor.id !== props.descriptor.id) {
            const html = props.descriptor.settings.text;
            const contentBlock = htmlToDraft(html);
            let editorState = EditorState.createEmpty();
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                return {
                    editorState: EditorState.createWithContent(contentState),
                    descriptor: props.descriptor,
                };
            }
        }
        return null;
    }

    componentDidMount() {
        const html = this.props.descriptor.settings.text;
        const contentBlock = htmlToDraft(html);
        let editorState = EditorState.createEmpty();
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            this.setState({
                editorState: EditorState.createWithContent(contentState),
                descriptor: this.props.descriptor,
            });
        }
    }

    render() {
        const { descriptor } = this.props;
        const { editorState } = this.state;
        return (
            <div style={{ color: 'black', backgroundColor: 'white' }}>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={(e) => this.onEditorStateChange(e)}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    toolbar={{
                        options: ['inline', 'colorPicker', 'textAlign', 'blockType', 'fontFamily', 'fontSize'],
                        inline: {
                            options: ['bold', 'italic', 'underline'],
                        },

                        blockType: {
                            inDropdown: true,
                            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
                        },
                    }}
                    className=" textSettings"
                />

                <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BorderEdit descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
                <ColorPicker descriptor={descriptor} />
            </div>
        );
    }
}

store.registerComponent({
    name: 'WYSIWYG',
    type: 'component',
    shelfComponent: draggableShelfComponent,
    screenComponent: draggableScreenComponent,
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

// export default draggableShelfComponent;
